import type React from 'react'

import { DropFile, DroppedFile } from './components'
import css from './styles.module.css'

interface Props {
  file: File | null
  loading: boolean
  error: string
  onSelectFile: (file: File) => void
  onClear: () => void
}

export const FileDropzone: React.FC<Props> = ({
  file,
  loading,
  error,
  onSelectFile,
  onClear,
}) => {
  return (
    <div className={css.file_dropzone}>
      {file ? (
        <DroppedFile error={error} fileName={file.name} onClear={onClear} />
      ) : (
        <DropFile loading={loading} error={error} onSelectFile={onSelectFile} />
      )}

      {error && <div className={css.error_text}>{error}</div>}
    </div>
  )
}
